import { render, staticRenderFns } from "./MediaOwnersSingleDetails.vue?vue&type=template&id=daaab0dc&"
import script from "./MediaOwnersSingleDetails.vue?vue&type=script&lang=js&"
export * from "./MediaOwnersSingleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports